if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

        
            // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
							// dispatch cart:change for the entire basket

						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

            
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* vDEV */
jQuery(document).ready(function($) {
    
  if (!customElements.get('product-popup-button')) {

    class ProductPopupButton extends HTMLElement {

      constructor() {
        super();
      }

      connectedCallback() {
        this.settings = {
          type: this.getAttribute('data-popup-type'),
        };
        
        if (window.location.hash == `#ProductPopup--${this.settings.type}`) {
          this.click();
        }

        this.events();
      }

      events() {

        document.addEventListener('variant:change', (event) => {
          console.log('ProductPopupButton', 'variant changed', event.detail);
        });
      }
    }

    customElements.define('product-popup-button', ProductPopupButton);
  }

});

if (!customElements.get('product-popup-form')) {

  class ProductPopupForm extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        n8n: {
          enabled: this.hasAttribute('data-n8n-enabled'),
        },
        variants: document.querySelectorAll('.product-form__controls-group input[type="radio"]'),
        tags: JSON.parse(document.getElementById('product-json-tags').innerText),
        form: this.querySelector('form'),
        fields: {
          wrapper: this.querySelector('.fields-container'),
          stores: this.querySelector('[data-field-type="stores"]'),
          variantId: this.querySelector('[data-field-type="variant_id"]'),
          variantValue: this.querySelector('[data-field-type="variant_value"]'),
          productImageUrl: this.querySelector('[data-field-type="product_image_url"]'),
        },
      };

      if (this.settings.n8n.enabled) {
        this.settings.n8n = {
          enabled: true,
          cookieId: 'shopify--n8n:stores',
          url: this.getAttribute('data-n8n-url'),
          alerts: {
            wrapper: this.querySelector('.n8n-form__alerts'),
            success: this.querySelector('.n8n-form__alert--success'),
            error: this.querySelector('.n8n-form__alert--error'),
          },
          products: this.querySelector('.n8n-form__products'),
        };

        this.settings.button = this.querySelector('button[data-n8n-form--action="submit"]');
        this.settings.fields.availableInStore = this.querySelector('[data-field-type="available_in_store"]');
      
      } else {
        this.settings.button = this.querySelector('button[type="submit"]');
      }
      
      this.events();
    }

    cookie = {
      
      get: (name) => {
        const value = `; ${document.cookie}`;
  
        if (document.cookie.includes(`; ${name}=`)) {
          const parts = value.split(`; ${name}=`);
          
          if (parts.length === 2) {
            return parts.pop().split(';').shift();
          }
        }
  
        return '';
      },
      
      set: (name, value, days = 365) => {
        var expires = "";
        
        //var days = 365;
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        
        const cookieText = `${name}=${value}; expires=${date.toUTCString()}; domain=.${window.location.hostname}; path=/`;
        document.cookie = cookieText;
      }
    };

    events() {
      
      document.addEventListener('variant:change', (event) => {
        const variantElement = event.detail.formElement.querySelector('[name="Shopify_option1"]:checked');

        if (!variantElement) return;
        
        if (this.settings.fields.variantId) {
          this.settings.fields.variantId.value = event.detail.variant.id;
        }
        
        if (this.settings.fields.variantValue) {
          this.settings.fields.variantValue.value = event.detail.variant.title;
        }
        
        if (this.settings.fields.productImageUrl) {
          this.settings.fields.productImageUrl.value = variantElement.dataset.variantImageUrl;
        }
      });

      if (this.settings.n8n.enabled) {

        document.addEventListener('popup:opened', (event) => {
          const popup = event.detail.popup;
          const popupForm = popup.querySelector('product-popup-form');

          if (!popupForm || popupForm != this) {
            return false;
          }
          
          this.storesField__render();
        });
  
        this.settings.form.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.form__submit();
          return false;
        });

        this.settings.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.form__submit();
        });
      }
    }

    /* Form: Stores field */
    async storesField__render() {
      let items;

      const cookieItems = this.storesField__getCookieItems();

      if (cookieItems.length) {
        items = cookieItems;
      
      } else {
        items = await this.storesField__getRemoteItems();

        if (items && items.length) {
          await this.storesField__setCookieItems(items);
        }
      }

      await this.storesField__renderByItems(items);
    }
  
    async storesField__renderByItems(items) {
      
      if (!items || !items.length) {
        return false;
      }

      if (!this.settings.fields.stores || this.settings.fields.stores.classList.contains('is-rendered')) {
        return false;
      }

      this.settings.fields.stores.classList.add('is-rendered');

      /* Availability */
      const formField__availability__match = this.settings.fields.stores.getAttribute('data-availability-match');
      const formField__availability__notMatch = this.settings.fields.stores.getAttribute('data-availability--not-match');
      /* /Availability */
      
      let itemI = 0;

      items.forEach((item) => {
        let optionElement;
        
        let item__availableInStore = false;
        let item__availability = formField__availability__notMatch;

        if (this.settings.tags.includes(item.code)) {
          item__availableInStore = true;
          item__availability = formField__availability__match;
        }
        
        /* Native select item */
        optionElement = document.createElement('option');
        optionElement.setAttribute('value', item.code);
        optionElement.setAttribute('data--available-in-store', item__availableInStore);

        optionElement.innerHTML = `${item.shop} - ${item__availability}`;
        this.settings.fields.stores.append(optionElement);
        /* /Native select item */
      });

      this.settings.fields.stores.addEventListener('change', () => {
        const option = this.settings.fields.stores.options[this.settings.fields.stores.selectedIndex];
        this.settings.fields.availableInStore.value = option.getAttribute('data--available-in-store');
      });

      this.settings.fields.stores.closest('.field').classList.remove('hidden');
    }
    
    storesField__getCookieItems() {
      const itemsText = this.cookie.get(this.settings.n8n.cookieId);
      let newItems = [];

      if (itemsText) {
        const items = JSON.parse(itemsText);
        
        for (let itemKey in items) {
          newItems.push({
            code: itemKey,
            shop: items[itemKey]
          });
        }
      }

      return newItems;
    }

    async storesField__setCookieItems(items) {
      let newItems = {};

      items.forEach((item) => {
        newItems[item.code] = item.shop;
      });
      
      this.cookie.set(this.settings.n8n.cookieId, JSON.stringify(newItems), 1);
    }

    async storesField__getRemoteItems() {
      const url = 'https://n8n.eye-oo.com/webhook/odoo/stores/try/get';

      return await fetch(url)
        .then((response) => {

          if (!response.ok) {
            return false;
          }
          
          return response.json();
        })
          .then((response) => {
            return response;
          });
    }
    /* /Form: Stores field */

    /* Form: Submit */
    async form__submit() {
      this.settings.button.setAttribute('disabled', 'disabled');

      if (this.settings.form.checkValidity()) {
        await this.n8n__submit();
        
      } else {
        this.settings.form.reportValidity();
        this.settings.button.removeAttribute('disabled');
      }
    }

    async n8n__submit() {
      const obj3 = this;
      
      this.settings.button.setAttribute('disabled', 'disabled');
      
      const formFields = this.settings.form.querySelectorAll('[data-n8n-form--name]');

      if (!formFields.length) {
        return false;
      }
      
      const formUrl = this.settings.n8n.url;
      const formMethod = 'post';
      const formBody = new FormData();

      formFields.forEach((formField) => {
        formField.setAttribute('value', formField.value);

        const formFieldNewName = formField.getAttribute('data-n8n-form--name');
        formBody.set(formFieldNewName, formField.value)
      });

      fetch(formUrl, {
        method: formMethod,
        body: formBody,
      })
        .then((response) => {
        
          if (!response.ok) {
            return false;
          }

          return response.json();
        })
        .then((response) => {
          
          if (!Array.isArray(response)) {
            obj3.settings.button.removeAttribute('disabled');

            return false;
          }

          return response;
        })
        .then((response) => {
          obj3.n8n__submitted(response);
        });
    }

    async n8n__submitted(items) {
      const obj3 = this;

      if (!items) {
        this.settings.button.removeAttribute('disabled');
        
        return false;
      }

      items.forEach((item) => {
        /* Alerts */
        if (item.message) {
          
          if (item.status == 'OK') {
            this.settings.n8n.alerts.success.querySelector('span').innerText = item.message;
            this.settings.n8n.alerts.success.classList.remove('hidden');
            this.settings.n8n.alerts.error.classList.add('hidden');
            
          } else {
            this.settings.n8n.alerts.success.classList.add('hidden');

            this.settings.n8n.alerts.error.querySelector('span').innerText = item.message;
            this.settings.n8n.alerts.error.classList.remove('hidden');
          }
          
          this.settings.n8n.alerts.wrapper.classList.remove('hidden');

        } else {
          this.settings.n8n.alerts.wrapper.classList.add('hidden');
        }
        /* /Alerts */
        
        /* Products */
        this.settings.n8n.products.innerHTML = '';

        if (item.status == 'KO' && item['products']) {
          
          item['products'].forEach((product) => {
            const itemElement = document.createElement('div');
            itemElement.innerHTML = `
              <div class="n8n-form__product">
                <div class="n8n-form__product-image">
                  <a href="${product.x_studio_url}">
                    <img
                      loading="lazy"
                      src="${product.x_studio_image_url}"
                      alt="${product.name}"
                    >
                  </a>
                </div>
                <div class="n8n-form__product-name">
                  <a href="${product.x_studio_url}">
                    ${product.name}
                  </a>
                </div>
              </div>
            `;
            formItems.append(itemElement);
          });
          
          this.settings.n8n.products.classList.remove('hidden');
        
        } else {
          this.settings.n8n.products.classList.add('hidden');
        }
        /* /Products */

        this.settings.fields.wrapper.classList.add('hidden');
      });
    }
    /* /Form: Submit */
  }

  customElements.define('product-popup-form', ProductPopupForm);
}

if (!customElements.get('product-form-buttons')) {

  class ProductFormButtons extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        buttons: {
          addToCart: this.querySelector('.product-form__submit'),
          notifyMe: this.querySelector('.product-popup-button--notify_me'),
          contactUs: this.querySelector('.product-popup-button--contact_us'),
          tryInStore: this.querySelector('.product-popup-button--try_in_store'),
        },
      };

      this.events();
    }

    events() {

      document.addEventListener('variant:change', (event) => {

        if (event.detail.variant.available && this.settings.buttons.contactUs) {
          this.settings.buttons.contactUs.classList.remove('hidden');

          if (this.settings.buttons.addToCart) {
            this.settings.buttons.addToCart.classList.add('hidden');
          }
          
          if (this.settings.buttons.addToCart) {
            this.settings.buttons.notifyMe.classList.add('hidden');
          }
          
          if (this.settings.buttons.addToCart) {
            this.settings.buttons.tryInStore.classList.add('hidden');
          }

        } else {

          if (this.settings.buttons.contactUs) {
            this.settings.buttons.contactUs.classList.add('hidden');
          }

          if (event.detail.variant.available) {
            this.settings.buttons.addToCart.classList.remove('hidden');
            
            if (this.settings.buttons.notifyMe) {
              this.settings.buttons.notifyMe.classList.add('hidden');
            }

            if (this.settings.buttons.tryInStore) {
              this.settings.buttons.tryInStore.classList.remove('hidden');
            }
            
          } else {
            this.settings.buttons.addToCart.classList.add('hidden');
            
            if (this.settings.buttons.notifyMe) {
              this.settings.buttons.notifyMe.classList.remove('hidden');
            }

            if (this.settings.buttons.tryInStore) {
              this.settings.buttons.tryInStore.classList.add('hidden');
            }
          }
        }
      });
    }
  }

  customElements.define('product-form-buttons', ProductFormButtons);
}

if (!customElements.get('product-form-colors')) {

  class ProductFormColors extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        wrapper: this.parentNode,
        tag: this.getAttribute('data-tag'),
        productId: this.getAttribute('data-product-id')
      };

      const q = `"${this.settings.tag}"`;
      const url = `${window.Shopify.routes.root}search?section_id=product-form-colors&q=${encodeURIComponent(q)}`;
      const content = this.querySelector('.product-form__controls-group');
        
      fetch(url)
        .then(response => response.text())
        .then(response => {
        const fetchContent = new DOMParser()
          .parseFromString(response, 'text/html')
          .querySelector('.product-form__controls-group');
        
        if (!fetchContent) {
          return;
        }

        let fetchProducts = fetchContent.querySelectorAll('a');

        if (!fetchProducts.length || fetchProducts.length < 2) {
          return;
        }

        fetchProducts.forEach((fetchProduct) => {
          const fetchProductId = fetchProduct.getAttribute('data-product-id');

          if (this.settings.productId == fetchProductId) {
            fetchProduct.classList.add('is-active');
          }
        });
          
        content.innerHTML = fetchContent.innerHTML;
        this.classList.remove('hidden');
      });
    }
  }

  customElements.define('product-form-colors', ProductFormColors);
}
/* /vDEV */